import { render, staticRenderFns } from "./OrderRowsCard.vue?vue&type=template&id=4f86be3f"
import script from "./OrderRowsCard.vue?vue&type=script&lang=js"
export * from "./OrderRowsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports